<template>
  <router-link :to="path" v-if="showEditFlg" class="table-btn"> 编辑 </router-link>
  <template v-if="record.status !== 'ygb' && bizType === 'project_examine'">
    <submit-approval-btn
      :loading="loading"
      @refresh="refreshApprovalDetail"
      :biz-type="bizType"
      :biz-id="bizId"
      :biz-name="bizName"
      :flg="showSubmitBtn"
      :access="examineAccess"
      class="table-btn"
    />
  </template>
  <template v-else-if="bizType !== 'project_examine'">
    <submit-approval-btn
      :loading="loading"
      @refresh="refreshApprovalDetail"
      className="table-btn"
      :biz-type="bizType"
      :biz-id="bizId"
      :biz-name="bizName"
      :flg="showSubmitBtn"
      :access="examineAccess"
    />
  </template>
  <agree-btn
    :loading="loading"
    @refresh="refreshApprovalDetail"
    className="table-btn"
    :biz-type="bizType"
    :biz-id="bizId"
    :flg="showAgreeBtn"
    :access="examineAccess"
  />

  <reject-btn
    :loading="loading"
    @refresh="refreshApprovalDetail"
    className="table-btn"
    :biz-type="bizType"
    :biz-id="bizId"
    :flg="showRejectBtn"
    :access="examineAccess"
  />
  <cancel-btn
    :loading="loading"
    @refresh="refreshApprovalDetail"
    className="table-btn"
    :biz-type="bizType"
    :biz-id="bizId"
    :flg="showCancelBtn"
    :access="examineAccess"
  />
  <!--//判断关联条件改为该保证金支付单下有已生效或者未生效，即非作废的保证金退回单，则不允许作废
  //只有保证金页面才调用这个接口,只有保证金下才判断invalid,invalid=0不可作废，invalid=1可作废-->
    <void-btn
      :loading="loading"
      className="table-btn"
      @refresh="refreshApprovalDetail"
      :biz-type="bizType"
      :biz-id="bizId"
      :biz-name="bizName"
      :flg="showVoidBtn && !existRelation"
      :access="examineAccess"
    />

  <!--只有项目登记有丢单按钮-->
  <template v-if="showLostOrderBtn && record.status !== 'ygb' && bizType === 'project_examine'">
    <lost-order-btn
      className="table-btn"
      :biz-id="bizId"
      :biz-type="bizType"
      :biz-name="bizName"
      :loading="loading"
      @refresh="refreshApprovalDetail"
      :access="examineAccess"
    ></lost-order-btn>
  </template>

  <router-link :to="viewPath" class="table-btn"> 查看 </router-link>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "ShowButton",
});
</script>

<script lang="ts" setup>
import { defineProps, defineEmits, PropType } from "vue";
import SubmitApprovalBtn from "./submit-approval-btn.vue";
import AgreeBtn from "./agree-btn.vue";
import RejectBtn from "./reject-btn.vue";
import CancelBtn from "./calcel-btn.vue";
import VoidBtn from "./void-btn.vue";
import LostOrderBtn from "./lost-order-btn.vue";

const props = defineProps({
  bizType: {
    type: String,
    default: "",
  },
  record: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  bizId: {
    type: String,
    default: "",
  },
  bizName: {
    type: String,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  examineAccess: {
    type: String,
  },
  showLostOrderBtn: {
    type: Boolean,
    default: false,
  },
  showVoidBtn: {
    type: Boolean,
    defalut: false,
  },
  showCancelBtn: {
    type: Boolean,
    default: false,
  },
  existRelation: {
    type: Boolean,
    default: false,
  },
  showRejectBtn: {
    type: Boolean,
    default: false,
  },
  showAgreeBtn: {
    type: Boolean,
    default: false,
  },
  showSubmitBtn: {
    type: Boolean,
    default: false,
  },
  path: {
    type: String,
    default: "",
  },
  viewPath: {
    type: String,
    default: "",
  },
  showEditFlg: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["refreshApprovalDetail"]);

function refreshApprovalDetail() {
  emit("refreshApprovalDetail");
}
</script>
